import React, { useEffect } from "react"

import Menu from "./menu"
import "bootstrap/dist/css/bootstrap.css"
import "./bootstrap-override.css"
import "./style.css"
import "./vs.css"
import icon from "./zang-spaces-icons.svg"
import { Helmet } from "react-helmet"
import hljs from "highlight.js"

export default ({ children, location }) => {
  useEffect(() => {
    document.querySelectorAll("pre").forEach(block => {
      hljs.highlightBlock(block)
    })
  }, [])
  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Avaya Spaces Developer Documentation</title>
      </Helmet>
      <nav className="navbar navbar-inverse navbar-fixed-top">
        <div className="container">
          {/* Brand and toggle get grouped for better mobile display */}
          <div className="navbar-header">
            <a className="navbar-brand docs-brand" href="/developers/docs">
              <img
                alt="logo"
                src={icon}
                className="img-responsive img-circle"
              />
              <span>Avaya Spaces Developer Documentation</span>
            </a>
            <p className="navbar-text" id="path" />
          </div>
          {/* Collect the nav links, forms, and other content for toggling */}
          <div
            className="collapse navbar-collapse"
            id="bs-example-navbar-collapse-1"
          />
        </div>
      </nav>
      <div className="container">
        <div className="row">
          <div className="col-md-4">
            <div id="mainMenu">
              <Menu location={location} />
            </div>
          </div>
          <div className="col-md-8">
            <div id="mainContent">
              <div className="well">{children}</div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
